
import Constant from '../Utils/Constant';

const NotFoundPage = ({
    title = "404",
    message = Constant.PAGE_NOT_FOUND_TITLE,
    description = Constant.PAGE_NOT_FOUND_MESSAGE,
    technicalMessage,
    buttonLabel = Constant.BACK_TO_HOME,
    onBack,
    iconClass = "fas fa-home me-2"
}) => {
    // Si aucune fonction de retour n'est fournie, retourne à l'accueil
    const handleClick = onBack || (() => { window.location.href = '/'; });

    return (
        <div className="not-found-page">
            <div className="not-found-content">
                {/* Titre principal */}
                <h1 className="not-found-title">{title}</h1>
                {/* Message d'erreur */}
                <p className="not-found-message">{message}</p>
                {description && (
                    <p className="not-found-description">{description}</p>
                )}
                {technicalMessage && technicalMessage !== description && (
                    <p className="not-found-technical-message" style={{fontSize:'0.9em', color:'#888', marginTop:8}}>{technicalMessage}</p>
                )}
                {/* Bouton d'action */}
                <button 
                    className="btn btn-primary btn-lg"
                    onClick={handleClick}
                >
                    {iconClass && <i className={iconClass}></i>}
                    {buttonLabel}
                </button>
            </div>
        </div>
    );
};

export default NotFoundPage;